<template>

  <b-container fluid class="p-row">
  </b-container>


</template>

<script>

export default {
  name: "Posts",
}
</script>

<style scoped>
.p-row {
  margin-top: 30px;
}
</style>